<script>
import DateRange from "@/components/DateRange";
import addDialog from "./DatesSystemDialog.vue";
import deleteDialog from "../../../../dialogs/DeleteDialog.vue";
import Vue from "vue";
import axios from "axios";

export default {
    name: "DatesSystem",
    components: {DateRange, addDialog, deleteDialog},
    data() {
        return {
            ENTITY: 'system-date',
            data: null,
            loading: true,
            isDialogDelete: false,
            isDialogAdd: false,
            selectedRows: [],
            filters: {},
            itemBeforeEditing: {},
            itemAfterEditing: {},
            columns: [{field: "hebrewName", header: "שם"}, {field: "shortName", header: "שם מקוצר"}, {
                field: "sort",
                header: "סדר"
            }],
        }


    },
    created() {
        this.fetchData()
    }
    ,
    methods: {
        addItem(item) {
            this.data.push(item);
        },
        deleteItem(choice) {
            this.loading = true

            this.isDialogDelete = false;
            if (choice) {
                const itemsIds = [];
                this.selectedRows.forEach((item) => {
                    itemsIds.push(item.id);
                });

                this.selectedRows.forEach((selected) => {
                    this.data = this.data.filter((item) => item.id !== selected.id);
                });

                axios.delete(`/${this.ENTITY}/delete-many`,
                    {
                        data: itemsIds
                    }
                ).then(() => {
                    this.loading = false
                    this.openNotification("success", `מעולה`, `מחקנו ${itemsIds.length}  רשומות מהמערכת`);
                    this.selectedRows = [];
                }).catch(() => {
                    this.loading = false
                    this.openNotification("danger", `אופס`, `לא הצלחנו למחוק את הרשומות מהמערכת`);
                    this.data.push(...this.selectedRows)
                    this.selectedRows = [];
                });

                this.isDialogDelete = false;
            }
        },
        async fetchData() {
            try {
                const {data} = await axios.get(`${this.ENTITY}/all`)
                console.log("responseresponse", data)
                this.data = data
            } catch (e) {
                console.log(e)
                this.openNotification("danger", `אופס`, `תקלה בטעינת נתוני תאריכי מערכת`);
            }
            this.loading = false
        },
        rowClass(data) {
            return data.active === false ? "row-unenabled" : null;
        },
        async onCellEditComplete(event) {
            console.log("event123", event)

            try {
                let objToSend = {}
                if (this.itemAfterEditing?.id === undefined) {
                    objToSend = event.data

                } else {
                    const index = this.data.findIndex(
                        (item) => item.id === this.itemAfterEditing.id
                    );
                this.data[index] = this.itemAfterEditing;
                Vue.set(this.data, index, this.itemAfterEditing);
                 objToSend = JSON.parse(JSON.stringify(this.itemAfterEditing));
                    objToSend.startDate = new Date(objToSend.startDate).getTime()
                    objToSend.endDate = new Date(objToSend.endDate).getTime()
                console.log("clone123", objToSend)
                console.log(this.itemAfterEditing)
            }
                console.log("objToSend123", objToSend)

                if (!objToSend.id) throw "error"
                await axios.put(`${this.ENTITY}/update`, objToSend)
                this.openNotification(
                    "success",
                    `מעולה`,
                    `רשומה התעדכנה`
                )
            } catch (e) {
                console.log(e)
                this.openNotification(
                    "danger",
                    `אופס`,
                    `${e} : רשומה לא התעדכנה`
                );
            }
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    }
    ,
}
</script>

<template>
    <div>
        <DataTable
                :rowClass="rowClass"
                :value="data"
                :selection.sync="selectedRows"
                @cell-edit-complete="onCellEditComplete"
                columnResizeMode="fit"
                dataKey="id"
                stateStorage="local"
                stateKey="system-messages-data-state"
                editMode="cell"
                :loading="loading"
                sortField="createdAt"
                :sortOrder="-1"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
        >
            <!-- header -->

            <template #header>
                <div class="p-p-2 table-header">
                    <div class="p-m-1 p-d-inline-flex">
                        <h1 style="text-align: center">זמני מערכת</h1>
                    </div>

                    <div class="p-d-flex">

                        <Button
                                v-tooltip.top="'מחיקה'"
                                v-if="selectedRows.length > 0"
                                icon="pi pi-trash"
                                class="p-mr-2 p-button-danger"
                                @click="isDialogDelete = true"
                        />
                        <Button
                                v-tooltip.top="'הוספה'"
                                icon="pi pi-plus"
                                class="p-mr-2 p-button-success"
                                @click="isDialogAdd = true"
                        />
                    </div>
                </div>
            </template>
            <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

            <!-- v-for -->
            <Column
                    headerStyle="text-align: rtl"
                    bodyStyle="text-align: right; overflow: visible"
                    sortable
                    v-for="col of columns"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
            >

                <template #editor="slotProps">
                        <Textarea
                                autoResize="true"
                                @input="onCellEdit($event, slotProps)"

                                v-if="slotProps.column.field !== 'id'"
                                :value="slotProps.data[slotProps.column.field]"
                        />
                    <div v-else>{{ slotProps.data[slotProps.column.field] }}</div>
                </template>
            </Column>

            <!-- start date-->
            <Column
                    bodyStyle="text-align: right; overflow: visible"
                    :field="'startDate'"
                    header="'תאריך התחלה'"
            >
                <template #body="slotProps">
                    {{ new Date(slotProps.data.startDate).toLocaleDateString() }}
                </template>
                <template #editor="slotProps">
                    <Calendar
                            @input="onCellEdit($event, slotProps)"
                            :touchUI="true"
                            :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data.startDate)"/>
                </template>
            </Column>

            <!-- end -->
            <Column
                    bodyStyle="text-align: right; overflow: visible"
                    :field="'endDate'"
                    header="'תאריך סיום'"
            >
                <template #body="slotProps">
                    {{ new Date(slotProps.data.endDate).toLocaleDateString() }}
                </template>
                <template #editor="slotProps">
                    <Calendar
                            @input="onCellEdit($event, slotProps)"
                            :touchUI="true"
                            :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data.endDate)"/>
                </template>
            </Column>


            <!--                active-->
            <Column
                    headerStyle="width: 5%; text-align: rtl"
                    bodyStyle="width: 5%; text-align: right; overflow: visible"
                    :field="'active'"
                    :header="'פעיל'"
            >
                <template #editor="slotProps">
                    <checkbox @input="onCellEdit($event, slotProps)"
                              v-model="slotProps.data.active" :binary="true"></checkbox>
                </template>
                <template #body="slotProps">
                    <checkbox v-model="slotProps.data.active" :binary="true"></checkbox>
                </template>
            </Column>
            <Column
                    headerStyle="width: 5%; text-align: rtl"
                    bodyStyle="width: 5%; text-align: right; overflow: visible"
                    :field="'default'"
                    :header="'ברירת מחדל'"
            >
                <template #editor="slotProps">
                    <checkbox
                              v-model="slotProps.data.default" :binary="true"></checkbox>
                </template>
                <template #body="slotProps">
                    <checkbox v-model="slotProps.data.default" :binary="true"></checkbox>
                </template>
            </Column>


            <template #footer>
                סה״כ {{ data ? data.length : 0 }} רשומות.
            </template>
        </DataTable>
        <add-dialog
                :show="isDialogAdd"
                v-on:addItem="addItem"
                v-on:closeDialog="isDialogAdd = false"
        />

        <delete-dialog
                :title="'מחיקת משתמש'"
                :context="`האם תרצה להסיר  ${selectedRows.length}   הודעות מהמערכת?`"
                :show="isDialogDelete"
                v-on:choice="deleteItem"
        />
    </div>
</template>


<style scoped>

</style>